import Paginate from 'vuejs-paginate'
import Status from '@/components/status'
import swal from 'sweetalert'
import Close from './close'
// import Corrective from './corrective'
import ViewInfo from './view-info'
import lodash from 'lodash'
import StatusCode from '@/status'
export default {
  name: 'list',
  components: {Paginate, Status, Close, ViewInfo},
  props: [],
  data () {
    return {
      per_page: 20,
      sort: 'desc',
      status: '',
      search: '',
      ctg_value: null,
      normalizer (node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children
        }
      },
      organization_id: null,
      loading: false,
      data_print: []
    }
  },
  computed: {
    category () {
      return this.$store.getters['CategoryChk/getListRecursive']
    },
    checklists () {
      return this.$store.getters['Checklist/getListChecklist']
    },
    last_page () {
      return this.$store.getters['Checklist/getLastPage']
    },
    total () {
      return this.$store.getters['Checklist/getTotal']
    },
    options () {
      return this.$store.getters['Status/getStatusChecklist']
    },
    fields () {
      return this.$store.getters['Checklist/getField']
    },
    checklist_item_status () {
      return this.$store.getters['ChecklistItemStatus/getListStatus']
    },
    organizations () {
      return this.$store.getters['Organization/getOrganization']
    }
  },
  mounted () {
    this.$loading.start()
    this.loading = true
    Promise.all([
      this.$store.dispatch('Checklist/getListChecklist', {page: 1, per_page: 20, sort: 'desc'}),
      this.options.length === 0 ? this.$store.dispatch('Status/getListStatus') : '',
      this.organizations.length === 0 ? this.$store.dispatch('Organization/getData', {page: 1, per_page: 'all'}) : '',
      this.checklist_item_status.length === 0 ? this.$store.dispatch('ChecklistItemStatus/getListStatus') : '',
      this.category.length === 0 ? this.$store.dispatch('CategoryChk/getListCtg') : ''
    ]).then(res => {
      // this.organizations = res[2]
      this.$loading.complete()
      this.loading = false
    }).catch(errors => {
      this.$loading.fail()
      this.loading = false
    })
  },
  methods: {
    addChecklist () {
      this.$router.push('create')
    },
    changeTotal () {
      this.$loading.start()
      this.$store.dispatch('Checklist/getListChecklist', {page: 1, per_page: this.per_page, status: this.status, sort: this.sort, search: this.search, organization_id: this.organization_id}).then(res => {
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },

    changePage (page) {
      this.$loading.start()
      this.$store.dispatch('Checklist/getListChecklist', {page: page, per_page: this.per_page, status: this.status, sort: this.sort, search: this.search, organization_id: this.organization_id}).then(res => {
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },

    edit (checklist) {
      this.$router.push(checklist.id + '/edit')
    },

    addChecklistItem (checklist) {
      if (parseInt(checklist.status.code) !== parseInt(StatusCode.SUBMITTING)) {
        swal({
          title: this.$t('checklist.error.add_group_checklist_item.title'),
          text: this.$t('checklist.error.add_group_checklist_item.text') + checklist.status.name,
          icon: 'warning'
        })
      } else {
        this.$router.push(checklist.id + '/checklist-item')
      }
    },

    view (checklist) {
      this.$router.push(checklist.id + '/view')
    },

    destroy (checklist) {
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
            this.$loading.start()
            this.$store.dispatch('Checklist/destroyChecklist', {
              checklist
            }).then((res) => {
              this.$notify({
                group: 'success',
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
              this.$loading.complete()
            }).catch(errors => {
              this.$loading.complete()
            })
          }
        })
    },

    approval (checklist) {
      this.$loading.start()
      this.$store.dispatch('Checklist/approvalChecklist', {checklist}).then(res => {
        checklist.status = res.status
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },
    rejection (checklist) {
      this.$loading.start()
      this.$store.dispatch('Checklist/rejectChecklist', {checklist}).then(res => {
        checklist.status = res.status
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },
    close (checklist) {
      if (parseInt(StatusCode.CLOSE) === parseInt(checklist.status.code)) {
        return false
      }
      this.$refs.close.show(checklist)
    },
    closeSuccess (checklist) {
      var index = lodash.findIndex(this.checklists, ['id', checklist.id])
      this.checklists.splice(index, 1, checklist)
      this.$notify({
        group: 'success',
        title: this.$t('notify.notify'),
        text: this.$t('notify.update_success')
      })
      this.$refs.close.hide()
    },
    corrective (checklist) {
      if (parseInt(StatusCode.CORRECTIVE) === parseInt(checklist.status.code)) {
        return false
      }
      // this.$refs.corrective.show(checklist)
      this.$router.push('/checklist/' + checklist.id + '/corrective')
    },
    correctiveSuccess (checklist) {
      var index = lodash.findIndex(this.checklists, ['id', checklist.id])
      this.checklists.splice(index, 1, checklist)
      this.$notify({
        group: 'success',
        title: this.$t('notify.notify'),
        text: this.$t('notify.update_success')
      })
      this.$refs.corrective.hide()
    },
    inProgress (checklist) {
      this.$loading.start()
      this.$store.dispatch('Checklist/inProgressChecklist', {checklist}).then(res => {
        checklist.status = res.status
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },
    filter () {
      this.$loading.start()
      this.$store.dispatch('Checklist/getListChecklist', {page: 1, per_page: this.per_page, status: this.status, sort: this.sort, search: this.search, organization_id: this.organization_id, ctg: this.ctg_value}).then(res => {
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },
    viewInfo (checklist) {
      this.$refs.viewInfo.show(checklist)
    },
    _reportFix (checklist) {
      this.$router.push('/checklist/' + checklist.id + '/corrective-result')
    },
    async printChecklist (checklist) {
      this.$loading.start()
      await this.$store.dispatch('Audit/getChecklistItemOfChecklist', {checklist}).then(res => {
        this.data_print = res
        this.$loading.complete()
        this.$nextTick(() => {
          var innerContents = document.getElementById('page').innerHTML
          var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no')
          popupWinindow.document.open()
          popupWinindow.document.write('<html><head><link rel="stylesheet" href="/static/bootstrap.css"/><link rel="stylesheet" type="text/css" href="/static/print.css" /><link rel="stylesheet" type="text/css" href="/static/style.css" /></head><body onload="window.print()">' + innerContents + '</html>')
          popupWinindow.document.close()
        })
      }).catch(errors => {
        console.log(errors)
        this.$loading.fail()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist/list/list.js